<div class="container mx-auto h-full">
  <div class="flex justify-center flex-col h-full">
    <form (submit)="this.submitTrackingCode(this.trackingCode)">
      <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-primary mb-4">
        <i class="fa-kit fa-solid-box-magnifying-glass"></i> Follow your transport
      </h1>
      <div class="flex flex-col md:flex-row md:items-end justify-center md:justify-start items-start">
        <div class="searchbar mb-6 md:mb-0 md:mr-6 w-full">
          <label class="label font-medium">
            <span class="text-lg" style="font-size: 1rem!important;">Enter your tracking code</span>
          </label>
          <input type="text" placeholder="Enter here" name="trackingCode" class="input input-bordered input-primary w-full" maxlength="25"
                 [(ngModel)]="this.trackingCode" oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '')"/>
        </div>
        <button class="w-full md:w-auto btn btn-primary" [disabled]="this.trackingCode.length === 0 || this.trackingCode.length > 25 "
        ><i class="fa-regular fa-magnifying-glass"></i>
          Search
        </button>
      </div>
    </form>
  </div>
</div>
